'use strict';
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a = require('./expr'), precedes = _a.precedes, walkExpr = _a.walkExpr;
var AGGREGATORS = require('./constants').AGGREGATORS;
/**
 * Find model by qualifiers.
 * @example
 * findModel(spell, ['comments'])
 * findModel(spell)
 *
 * @param {Spell} spell
 * @param {string[]} qualifiers
 */
function findModel(spell, qualifiers) {
    var qualifier = qualifiers && qualifiers[0];
    var Model = qualifier && qualifier != spell.Model.tableAlias
        ? (spell.joins.hasOwnProperty(qualifier) ? spell.joins[qualifier].Model : null)
        : spell.Model;
    if (!Model)
        throw new Error("Unabled to find model ".concat(qualifiers));
    return Model;
}
/**
 * Format identifiers into escaped string with qualifiers.
 * @param {Spell}  spell
 * @param {Object} ast
 */
function formatIdentifier(spell, ast) {
    var value = ast.value, qualifiers = ast.qualifiers;
    var Model = findModel(spell, qualifiers);
    var column = Model.unalias(value);
    var escapeId = spell.Model.driver.escapeId;
    if (qualifiers && qualifiers.length > 0) {
        return "".concat(qualifiers.map(escapeId).join('.'), ".").concat(escapeId(column));
    }
    return escapeId(column);
}
var extractFieldNames = ['year', 'month', 'day'];
function formatFuncExpr(spell, ast) {
    var name = ast.name, args = ast.args;
    var type = spell.Model.driver.type;
    // https://www.postgresql.org/docs/9.1/static/functions-datetime.html
    if (type === 'postgres' && extractFieldNames.includes(name)) {
        return "EXTRACT(".concat(name.toUpperCase(), " FROM ").concat(args.map(function (arg) { return formatExpr(spell, arg); }).join(', '), ")");
    }
    return "".concat(name.toUpperCase(), "(").concat(args.map(function (arg) { return formatExpr(spell, arg); }).join(', '), ")");
}
function formatLiteral(spell, ast) {
    var value = ast.value;
    if (value == null)
        return 'NULL';
    if (Array.isArray(value)) {
        if (value.length)
            return "(".concat(value.map(function () { return '?'; }).join(', '), ")");
        return '(NULL)';
    }
    return '?';
}
/**
 * Format the abstract syntax tree of an expression into escaped string.
 * @param {Spell}  spell
 * @param {Object} ast
 */
function isAggregatorExpr(spell, ast) {
    var type = ast.type, name = ast.name, args = ast.args;
    switch (type) {
        case 'literal':
        case 'subquery':
        case 'wildcard':
        case 'mod':
        case 'id':
        case 'raw':
        case 'op':
            return false;
        case 'alias':
            return isAggregatorExpr(spell, args[0]);
        case 'func':
            return AGGREGATORS.includes(name);
        default:
            throw new Error("Unexpected type ".concat(type));
    }
}
/**
 * Format the abstract syntax tree of an expression into escaped string.
 * @param {Spell}  spell
 * @param {Object} ast
 */
function formatExpr(spell, ast) {
    var type = ast.type, name = ast.name, value = ast.value, args = ast.args;
    switch (type) {
        case 'literal':
            return formatLiteral(spell, ast);
        case 'subquery':
            return "(".concat(value.toSqlString(), ")");
        case 'wildcard':
            return '*';
        case 'alias':
            return "".concat(formatExpr(spell, args[0]), " AS ").concat(formatIdentifier(spell, ast));
        case 'mod':
            return "".concat(name.toUpperCase(), " ").concat(formatExpr(spell, args[0]));
        case 'id':
            return formatIdentifier(spell, ast);
        case 'op':
            return formatOpExpr(spell, ast);
        case 'func':
            return formatFuncExpr(spell, ast);
        case 'raw':
            // return value directly
            return value;
        default:
            throw new Error("Unexpected type ".concat(type));
    }
}
/**
 * Check if current token is logical operator or not, e.g. `AND`/`NOT`/`OR`.
 * @param {Object} ast
 */
function isLogicalOp(_a) {
    var type = _a.type, name = _a.name;
    return type == 'op' && ['and', 'not', 'or'].includes(name);
}
/**
 * Format `{ type: 'op' }` expressions into escaped string.
 * @param {Spell}  spell
 * @param {Object} ast
 */
function formatOpExpr(spell, ast) {
    var name = ast.name, args = ast.args;
    var params = args.map(function (arg) {
        return isLogicalOp(ast) && isLogicalOp(arg) && precedes(name, arg.name) < 0
            ? "(".concat(formatExpr(spell, arg), ")")
            : formatExpr(spell, arg);
    });
    if (name == 'between' || name == 'not between') {
        return "".concat(params[0], " ").concat(name.toUpperCase(), " ").concat(params[1], " AND ").concat(params[2]);
    }
    if (name == 'not')
        return "NOT ".concat(params[0]);
    if ('!~-'.includes(name) && params.length == 1)
        return "".concat(name, " ").concat(params[0]);
    if (args[1].type == 'literal' && args[1].value == null && !isLogicalOp(ast)) {
        if (!['=', '!='].includes(name)) {
            throw new Error("Invalid operator ".concat(name, " against null"));
        }
        return "".concat(params[0], " ").concat(name === '=' ? 'IS' : 'IS NOT', " NULL");
    }
    // IN (1, 2, 3)
    // IN (SELECT user_id FROM group_users)
    if ((args[1].type == 'literal' && Array.isArray(args[1].value)) || args[1].type == 'subquery') {
        var op = name;
        if (name == '=') {
            op = 'in';
        }
        else if (name == '!=') {
            op = 'not in';
        }
        if (!['in', 'not in'].includes(op)) {
            throw new Error("Invalid operator ".concat(name, " against ").concat(args[1].value));
        }
        return "".concat(params[0], " ").concat(op.toUpperCase(), " ").concat(params[1]);
    }
    if (params[1] !== '') {
        return "".concat(params[0], " ").concat(name.toUpperCase(), " ").concat(params[1]);
    }
}
/**
 * Format an array of conditions into an expression. Conditions will be joined with `AND`.
 * @param {Object[]} conditions - An array of parsed where/having/on conditions
 */
function formatConditions(spell, conditions) {
    return conditions
        .map(function (condition) {
        return isLogicalOp(condition) && condition.name == 'or' && conditions.length > 1
            ? "(".concat(formatExpr(spell, condition), ")")
            : formatExpr(spell, condition);
    })
        // filter empty condition
        .filter(function (condition) { return !!condition; })
        .join(' AND ');
}
/**
 * The `... IS NULL` predicate is not parameterizable.
 * - https://github.com/brianc/node-postgres/issues/1751
 * @param {Array} values the collected values
 * @param {Object} ast the abstract syntax tree
 * @returns {Array} values
 */
function collectLiteral(spell, ast, values) {
    walkExpr(ast, function (itr) {
        var type = itr.type, value = itr.value;
        if (type === 'op' && !isLogicalOp(itr)) {
            coerceLiteral(spell, itr);
        }
        else if (type == 'literal' && value != null) {
            if (Array.isArray(value)) {
                values.push.apply(values, __spreadArray([], __read(value), false));
            }
            else {
                values.push(value);
            }
        }
    });
    return values;
}
function coerceLiteral(spell, ast) {
    var e_1, _a;
    var args = ast.args;
    var firstArg = args[0];
    if (firstArg.type !== 'id')
        return;
    var model = findModel(spell, firstArg.qualifiers);
    var attribute = model && model.attributes[firstArg.value];
    if (!attribute)
        return;
    if (attribute.virtual) {
        throw new Error("unable to use virtual attribute ".concat(attribute.name, " in model ").concat(model.name));
    }
    try {
        for (var _b = __values(args.slice(1)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var arg = _c.value;
            if (arg.type === 'literal') {
                // { params: { $like: '%foo%' } }
                if (attribute.jsType === JSON && typeof arg.value === 'string')
                    continue;
                arg.value = attribute.uncast(arg.value, false);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
module.exports = { formatExpr: formatExpr, formatConditions: formatConditions, collectLiteral: collectLiteral, isAggregatorExpr: isAggregatorExpr };
//# sourceMappingURL=expr_formatter.js.map